import React, { useState, useEffect, useContext } from "react";
import CableTable from "./cableSubscriptionTable";
import Modal from "react-bootstrap/Modal";
import AddCable from "./cableSubscriptionAdd";
import AuthContext from "../context/AuthContext";
import axios from "axios";
import { API_URL } from "../components/api";

function SubscriptionCable() {
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);

  const handleShow = () => setShow(true);

  const { user } = useContext(AuthContext);
  const [data, setData] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const authTokens = JSON.parse(localStorage.getItem("authTokens"));
        const response = await axios.get(`${API_URL}/administration/groups/`, {
          headers: {
            Authorization: `Bearer ${authTokens.access}`,
          },
          params: {
            username: user.username,
          },
        });

        if (response.status === 200) {
          setData(response.data);
        }
      } catch (error) {
        console.error(error);
      }
    };

    fetchData();
  }, [user.username]);
  return (
    <div className="Plans">
      <div className="main">
        <div>
          <button onClick={handleShow} className="AddClient">
            Add Cable Subscription
          </button>
        </div>
        <CableTable />
      </div>
      <Modal show={show} onHide={handleClose}>
        <div className="forma">
          <Modal.Header closeButton>
            <Modal.Title>Add Cable Subscription</Modal.Title>
          </Modal.Header>
          <AddCable />
        </div>
      </Modal>
    </div>
  );
}

export default SubscriptionCable;
